// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"14":"fancyapps","644":"jcf","749":"swiperNavigation","779":"fancyappscss"}[chunkId] || chunkId) + ".bundle.js";
};